<template>
  <div class="c-p-t-1">
    <div class="order_info_con">
      <div class="r-top font-32 c-m-b-15 bold">
        <div>{{ preOrderDetail.TicketName }}</div>
      </div>
      <div class="font-28">
        <div class="c-m-b-8">
          <span>数量：</span><span class="font-24 c-m-l-8">X</span
          ><span class="uni-mr-5">{{ preOrderDetail.goodsNum }}</span>
        </div>
        <div class="f-bt">
          <div>
            <span>价格：</span><span class="font-24">￥</span
            >{{ preOrderDetail.GrouponPrice }}
          </div>
          <div>
            <span>总价：</span><span class="font-24">￥</span>{{ allPrice }}
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="c-tc font-34">
        <!-- <span>付款倒计时：</span>
				<u-count-down :time="timeData" format="HH:mm:ss">

				</u-count-down> -->
      </div>
      <van-button
        color="var(--tc)"
        round
        @click="submitGetRequest"
        :disabled="!sureType"
        >立即支付</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getFlashOrderResult } from "@/api/activity";

import { handleLocalStorage } from "@/utils/index.js";
export default {
  data() {
    return {
      preOrderDetail: {},
      allPrice: 0,
      timeData: 0,
      isCanClick: true,
      sureType: false,
    };
  },
  mounted() {
    this.preOrderDetail = handleLocalStorage.get("preOrderDetail");
    // this.timeData = getTimeObj("2023-07-20 23:11:24")
    this.allPrice =
      this.preOrderDetail.GrouponPrice * this.preOrderDetail.goodsNum;
    this.handleSetLoading();
    this.handleCheckOrder();
    this.orderInterval = setInterval(() => {
      this.handleCheckOrder();
    }, 3000);
  },
  destroyed() {
    console.log("离开=======");
    if (this.orderInterval) clearInterval(this.orderInterval);
  },
  methods: {
    handleSetLoading() {
      Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "订单生成中...",
      });
    },
    // 查询是否锁定抢购库存
    handleCheckOrder() {
      let param = {
        VpnId: this.$store.state.vpnId,
        EventsId: [this.preOrderDetail.EventId],
      };

      getFlashOrderResult(param)
        .then((res) => {
          this.handleSetLoading();
          if (res && res[0]) {
            if (res[0].OrderId) {
              Toast.clear();
              if (this.orderInterval) clearInterval(this.orderInterval);
              this.sureType = true;
              this.orderId = res[0].OrderId;
              this.$store.commit("setStoreVal", { orderId: res[0].OrderId });
            } else if (res[0].Error) {
              Toast.clear();
              if (this.orderInterval) clearInterval(this.orderInterval);
              this.$toast(res[0].Error);
            }
          } else {
            Toast.clear();

            if (this.orderInterval) clearInterval(this.orderInterval);
            this.$toast("没有查询到订单，请重新提交订单");
          }
        })
        .catch((err) => {
          Toast.clear();
        });
    },
    submitGetRequest() {
      // if (this.isSubmiting) {
      //   this.$toast("正在请求中，请稍后");
      //   return;
      // }
      // if (!this.isCanClick) {
      //   this.$toast("操作太频繁，请稍后");
      //   return;
      // }
      // this.isSubmiting = true;
      // this.isCanClick = false;
      // setTimeout(() => {
      //   this.isCanClick = true;
      // }, 3000);
      // const params = {
      //   EventId: this.preOrderDetail.EventId,
      //   EventClientId: 0, //活动终端类型，0:H5 1:小程序
      //   ProductId: this.preOrderDetail.TicketId,
      //   Quantity: this.preOrderDetail.goodsNum,
      // };
      // takeCoupon(params)
      //   .then((res) => {
      // this.isSubmiting = false;

      this.$router.replace({
        name: "PayList",
        query: { id: this.orderId, fromPage: "flash" },
      });
      // })
      // .catch((err) => {
      //   this.isSubmiting = false;
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.order_info_con {
  border-radius: 20px;
  margin: 30px;
  padding: 20px;
  background-color: #fff;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 130px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 0 32px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
</style>
